// Google AdSense settings. NEXT_PUBLIC_* values are baked in at build time;
// when the client ID is empty (always on localhost) AdSlot shows a placeholder.

export type AdPosition = "left" | "right" | "inline";

export const adsConfig = {
  client: process.env.NEXT_PUBLIC_ADSENSE_CLIENT ?? "",
  slots: {
    left: process.env.NEXT_PUBLIC_ADSENSE_SLOT_LEFT ?? "",
    right: process.env.NEXT_PUBLIC_ADSENSE_SLOT_RIGHT ?? "",
    inline: process.env.NEXT_PUBLIC_ADSENSE_SLOT_INLINE ?? "",
  } satisfies Record<AdPosition, string>,
};

/** Line for public/ads.txt, e.g. "ca-pub-123" →
 *  "google.com, pub-123, DIRECT, f08c47fec0942fa0". Empty when no client ID. */
export function adsTxt(client: string): string {
  const id = client.trim().replace(/^ca-/, "");
  if (!/^pub-\d+$/.test(id)) return "";
  return `google.com, ${id}, DIRECT, f08c47fec0942fa0\n`;
}
